import React, { useState, useEffect } from 'react';
import './CookieBanner.css';

function CookieBanner() {
  const [showBanner, setShowBanner] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [preferences, setPreferences] = useState({
    necessary: true, // Sempre true, non modificabile
    analytics: false,
    marketing: false
  });

  useEffect(() => {
    // Controlla se l'utente ha già dato il consenso
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      // Mostra il banner dopo un breve delay
      setTimeout(() => setShowBanner(true), 1000);
    }
  }, []);

  const savePreferences = (prefs) => {
    localStorage.setItem('cookieConsent', JSON.stringify({
      timestamp: new Date().toISOString(),
      preferences: prefs
    }));

    // Aggiorna Google Analytics consent
    if (window.updateGAConsent) {
      window.updateGAConsent(prefs);
    }

    setShowBanner(false);
    setShowSettings(false);
  };

  const acceptAll = () => {
    const allAccepted = {
      necessary: true,
      analytics: true,
      marketing: true
    };
    savePreferences(allAccepted);
  };

  const rejectAll = () => {
    const onlyNecessary = {
      necessary: true,
      analytics: false,
      marketing: false
    };
    savePreferences(onlyNecessary);
  };

  const saveCustom = () => {
    savePreferences(preferences);
  };

  if (!showBanner) return null;

  return (
    <>
      <div className="cookie-banner">
        <div className="cookie-banner-content">
          <div className="cookie-banner-text">
            <h3>🍪 Utilizzo dei Cookie</h3>
            <p>
              Utilizziamo cookie per migliorare la tua esperienza di navigazione.
              I cookie essenziali sono necessari per il funzionamento del sito,
              mentre altri ci aiutano a migliorare i nostri servizi.
            </p>
          </div>
          <div className="cookie-banner-actions">
            <button onClick={acceptAll} className="btn-cookie-accept">
              Accetta Tutti
            </button>
            <button onClick={rejectAll} className="btn-cookie-reject">
              Rifiuta Tutti
            </button>
            <button onClick={() => setShowSettings(true)} className="btn-cookie-settings">
              Personalizza
            </button>
          </div>
        </div>
      </div>

      {showSettings && (
        <div className="cookie-modal-overlay" onClick={() => setShowSettings(false)}>
          <div className="cookie-modal" onClick={(e) => e.stopPropagation()}>
            <div className="cookie-modal-header">
              <h2>Preferenze Cookie</h2>
              <button
                className="cookie-modal-close"
                onClick={() => setShowSettings(false)}
              >
                ✕
              </button>
            </div>

            <div className="cookie-modal-body">
              <div className="cookie-category">
                <div className="cookie-category-header">
                  <div>
                    <h4>Cookie Essenziali</h4>
                    <p>Necessari per il funzionamento del sito. Non possono essere disabilitati.</p>
                  </div>
                  <label className="cookie-toggle disabled">
                    <input type="checkbox" checked={true} disabled />
                    <span className="toggle-slider"></span>
                  </label>
                </div>
              </div>

              <div className="cookie-category">
                <div className="cookie-category-header">
                  <div>
                    <h4>Cookie Analytics</h4>
                    <p>Ci aiutano a capire come i visitatori interagiscono con il sito raccogliendo dati anonimi.</p>
                  </div>
                  <label className="cookie-toggle">
                    <input
                      type="checkbox"
                      checked={preferences.analytics}
                      onChange={(e) => setPreferences({...preferences, analytics: e.target.checked})}
                    />
                    <span className="toggle-slider"></span>
                  </label>
                </div>
              </div>

              <div className="cookie-category">
                <div className="cookie-category-header">
                  <div>
                    <h4>Cookie Marketing</h4>
                    <p>Utilizzati per mostrare annunci personalizzati in base ai tuoi interessi.</p>
                  </div>
                  <label className="cookie-toggle">
                    <input
                      type="checkbox"
                      checked={preferences.marketing}
                      onChange={(e) => setPreferences({...preferences, marketing: e.target.checked})}
                    />
                    <span className="toggle-slider"></span>
                  </label>
                </div>
              </div>
            </div>

            <div className="cookie-modal-footer">
              <button onClick={saveCustom} className="btn-cookie-save">
                Salva Preferenze
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default CookieBanner;
